"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageHeader = void 0;
var react_1 = __importDefault(require("react"));
var Lockup_1 = __importDefault(require("../Lockup"));
var Grid_1 = __importDefault(require("../Grid"));
var patterns_1 = require("../../misc/patterns");
var styles_1 = require("./styles");
var GRID_1_ROW_GAP = { small: 24, medium: 40, large: 60, xlarge: 60 };
var GRID_1_CELL_SPAN_1 = {
    small: 'full',
    medium: 6,
    large: 8,
    xlarge: 8,
};
var PageHeader = function (_a) {
    var title = _a.title, titleMaxWidth = _a.titleMaxWidth, subtitle = _a.subtitle, _b = _a.subtitleMaxWidth, subtitleMaxWidth = _b === void 0 ? 24 : _b, _c = _a.compact, compact = _c === void 0 ? false : _c, backgroundVersion = _a.backgroundVersion, backgroundColor = _a.backgroundColor, commonProps = __rest(_a, ["title", "titleMaxWidth", "subtitle", "subtitleMaxWidth", "compact", "backgroundVersion", "backgroundColor"]);
    return (react_1.default.createElement(patterns_1.Background, { noise: true, shapes: true, color: backgroundColor, version: backgroundVersion, contentFocus: "left" },
        react_1.default.createElement(styles_1.Wrapper, __assign({ "data-component-name": "PageHeader" }, commonProps, { "$align": "left", "$compact": compact }),
            react_1.default.createElement(Grid_1.default, { rowGap: GRID_1_ROW_GAP },
                react_1.default.createElement(Grid_1.default.Cell, { span: GRID_1_CELL_SPAN_1 },
                    react_1.default.createElement(Lockup_1.default, { title: title, titleMaxWidth: titleMaxWidth, subtitle: subtitle, subtitleMaxWidth: subtitleMaxWidth, align: "left" }))))));
};
exports.PageHeader = PageHeader;
exports.default = exports.PageHeader;
